/**
 * Created by Ning Jiang on 11/8/2017.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {NudgeReelEvent} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeReelEvent";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Elastic, TimelineLite} from "gsap";
import {FreespinsLeftIndicator} from "../../freespinsleft/FreespinsLeftIndicator";
import {WildNudgeNudgeReelController} from "../../reel/nudgereel/WildNudgeNudgeReelController";
import {WildNudgeReelSymbol} from "../../reelsymbol/WildNudgeReelSymbol";
import {WildNudgeScatterReelSymbol} from "../../reelsymbol/WildNudgeScatterReelSymbol";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";
import {NudgeScatterWPView} from "./NudgeScatterWPView";

export class NudgeScatterWPController extends WinPresentationController {

    private static readonly NUDGE_STEP_SPEED:number = 0.6;

    private _view:NudgeScatterWPView;
    private _nudgeData:WildNudgeParsedGameData | null;
    private _nudgeState:boolean[];
    private _isNudging:boolean = false;
    private _scatterPositions:number[] | undefined;
    private _currentScatterIndexes:number[];
    private _fsLeft:number;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "NudgeScatter", skippable : false});

        this._view = new NudgeScatterWPView();
        this.initValues();
    }

    private initValues():void {
        this._nudgeState = ArrayHelper.initArrayWithValues<boolean>(5, () => {return false;});
        this._currentScatterIndexes = ArrayHelper.initArrayWithValues<number>(5, () => {return -1});
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_STEP_COMPLETED, (event:GameEvent) => this.onNudgeStepCompleted(event.params[0]));
        // The NUDGE_COMPLETE event is shared by different nudge features, have to make sure they are not conflict.
        EventHandler.addEventListener(this, NudgeReelEvent.NUDGE_COMPLETED, (event:GameEvent) => this.onNudgeCompleted(event.params[0]));
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        this._nudgeData = data;
        this._scatterPositions = data.scatterPositions;
        this._fsLeft = data.freespinsLeft;
    }

    protected hasWin():boolean {
        Logger.logDev(`server data doScatterNudge: ${this._nudgeData!.doScatterNudge.toString()}`);
        return this._nudgeData!.doScatterNudge.indexOf(true) > -1;
    }

    protected startWinPresentation():void {
        this.dimAllOtherSymbols(false);

        this._isNudging = true;
        let delay:number = this._nudgeData!.singleWin > 0 ? 0.5 : 0;
        this._nudgeData!.doScatterNudge.forEach((doNudge:boolean, reelId:number) => {
            if(doNudge) {
                this.doScatterReelNudge(reelId, false, delay);
                delay += (4 - this._scatterPositions![reelId]) * NudgeScatterWPController.NUDGE_STEP_SPEED;
            }
        });
        EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.UPDATE_LEFT_NUMBER, 0));
    }

    private dimAllOtherSymbols(isAbort:boolean):void {
        //symbols 0-9 on the reel are dimmed out, including the ones on top and the bottom of the visible ones for nudge
        for(let i:number = 0; i < GameConfig.instance.REELS_NUM; i++) {
            Reels.getReel(i)!.allSymbols.forEach((symbol:StateReelSymbol) => {
                if(symbol && symbol.symName !== ReelSymbolName.SCATTER) {
                    symbol.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.noWin!,
                        fadeInDuration : isAbort ? 0 : 1
                    });
                }
            });
        }
    }

    private doScatterReelNudge(reelId:number, isAbort:boolean, delay:number):void {
        if(!isAbort) {
            this._nudgeState[reelId] = true;
        }
        const index:number = this._scatterPositions![reelId];
        if(MathHelper.isInRange(index, 0, 3)) {
            if(isAbort) {
                (<WildNudgeNudgeReelController>Reels.getReel(reelId)).abortNudge(4 - index);
            } else {
                this._currentScatterIndexes[reelId] = index;
                (<WildNudgeNudgeReelController>Reels.getReel(reelId)).nudge(4 - index, NudgeScatterWPController.NUDGE_STEP_SPEED, Elastic.easeIn.config(1, 1), delay);
            }
            return;
        }

        debugger;
        throw new Error(`NudgeScatterWPController.doScatterReelNudge():There is no visible Scatter in a nudging reel. reelId = ${reelId}`);
    }

    private onNudgeStepCompleted(reelId:number):void {
        if(this._nudgeState[reelId]) {
            EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.UPDATE_LEFT_NUMBER));
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_NUDGE);
            let positions:[number, number] = Helper.getSymbolPositions(reelId, this._currentScatterIndexes[reelId]);
            this._view.showAddFreespin(positions);
            this._currentScatterIndexes[reelId]++;
        }
    }

    private onNudgeCompleted(reelId:number):void {
        if(!this._isNudging) {
            return;
        }

        // reset the symbol to turn off fire.
        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._currentScatterIndexes[reelId]);
        if(scatter) {
            scatter.changeState({
                state : GameConfig.instance.SYMBOL_STATES.normal,
                fadeInDuration : 0.1,
                replay : false
            });
        }

        this._nudgeState[reelId] = false;
        this._currentScatterIndexes[reelId] = -1;
        Logger.logDev(`NudgeScatterWPController.onNudgeCompleted(reelId:${reelId}): nudgeState : ${this._nudgeState.toString()}`);
        if(this._nudgeState.indexOf(true) > -1) {
            return;
        }

        this._isNudging = false;

        const timer:TimelineLite = new TimelineLite();
        timer.add(() => {
            this.finish();
        }, 0.5);
    }

    public abort():void {
        if(this._isPlaying && this._skippable) {
            Logger.logDev(`[WinPresentation]-${this.moduleName}.abort()`);
            EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.WIN_PRESENTATION_ABORTED, this.moduleName));

            if(this._isNudging) {
                this._nudgeState.forEach((isNudging:boolean, reelId:number) => {
                    if(isNudging) {
                        // Abort don't send complete event so it will not trigger onNudgeCompleted() again.
                        (<WildNudgeNudgeReelController>Reels.getReel(reelId)).abortNudge();
                    }
                });
            }
        }
    }

    protected stopWinPresentation(isAbort:boolean):void {
        SlotGame.keypad.setZeroBetSpinCounter(this._fsLeft);
        this._isNudging = false;

    }

    protected resetFeature():void {
        // To set the fs scatters landing on top of the view back on fire for the new spin. I am lazy so I do it here.
        if(this._nudgeData!.nextMode === GameMode.FREESPIN) {
            this._nudgeData!.reels.forEach((reel:string[], reelId:number) => {
                if(reel[0] === ReelSymbolName.SCATTER) {
                    const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, -1);
                    if(scatter) {
                        (<WildNudgeScatterReelSymbol>scatter).playFreespinScatterAttentionOverlay();
                    }
                }
            })
        }

        this._nudgeData = null;
        this.initValues();
    }
}